import React from 'react';
import { Button } from '../components/Button';
import { DarkCard, LightCard, CheckListItem } from '../components/Cards';
import { HeroDecorations, ImageDecorations, AboutDecorations } from '../components/Decorations';
import { EyeIcon, FingerprintIcon, AnchorIcon, TrendingUpIcon } from '../components/Icons';
import { CheckCircle2, Heart, Compass, Sparkles, Palette, Briefcase, Wrench, GitBranch } from 'lucide-react';
export function Despre() {
  return <main className="flex-grow bg-rise-white" data-id="element-633">
      {/* SECTION 1 - HERO (Light) - text left, photo top right */}
      <section className="relative py-12 md:py-20 bg-rise-white overflow-hidden" data-id="element-634">
        <HeroDecorations data-id="element-635" />
        <div className="max-w-rise-content mx-auto px-6 relative z-10" data-id="element-636">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-637">
            {/* Text column */}
            <div className="flex flex-col items-center lg:items-start text-center lg:text-left order-2 lg:order-1" data-id="element-638">
              <span className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-black border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-639">
                Despre mine
              </span>
              <h1 className="font-playfair text-[36px] md:text-[56px] text-rise-black leading-tight mb-4" data-id="element-640">
                Teodora Trifu
              </h1>
              <h2 className="font-playfair italic text-rise-gold text-[24px] md:text-[32px] leading-tight mb-6 max-w-xl" data-id="element-641">
                De la „nu sunt suficient(ă)" la „știu cine sunt"
              </h2>
              <p className="font-dm-sans text-[16px] md:text-[18px] tracking-wide text-rise-gray mb-6 max-w-xl" data-id="element-642">
                Consilier pentru dezvoltare personală · 9 ani experiență cu
                tineri · Creatorul R.I.S.E. – Realitate • Identitate •
                Stabilitate • Evoluție
              </p>
              <p className="font-dm-sans text-[19px] text-rise-gray mb-10 leading-relaxed max-w-xl" data-id="element-643">
                Nu sunt aici să-ți spun „gândește pozitiv". Sunt aici să-ți ofer
                structură când mintea ta e în haos. Și pași reali când simți că
                viața ta e pe pauză.
              </p>
              <div className="flex flex-col gap-4 w-full max-w-sm" data-id="element-644">
                <Button variant="primary" href="https://comunitatearise.ro/ofertarise" target="_top" className="w-full" data-id="element-645">
                  Intră în Programul R.I.S.E.
                </Button>
                <Button variant="secondary-dark" href="https://comunitatearise.ro/comunitaterise" target="_top" className="w-full" data-id="element-646">
                  Intră în Comunitatea R.I.S.E.
                </Button>
                <Button variant="secondary-dark" href="https://comunitatearise.ro/coaching1la1" target="_top" className="w-full" data-id="element-647">
                  Aplică pentru 1:1 cu Teodora
                </Button>
              </div>
            </div>

            {/* Image column - top right */}
            <div className="order-1 lg:order-2 relative max-w-md mx-auto w-full" data-id="element-648">
              <ImageDecorations type={1} data-id="element-649" />
              <img src="https://cdn.magicpatterns.com/uploads/5cTB7VyUXGVsL6aadBqWkg/Teodora_2.jpg" alt="Teodora Trifu" className="w-full h-auto aspect-[3/4] object-cover object-top rounded-xl shadow-xl relative z-10" data-id="element-650" />
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 2 — Tineri capabili (Dark) */}
      <section className="py-12 md:py-20 bg-rise-anthracite" data-id="element-651">
        <div className="max-w-rise-content mx-auto px-6" data-id="element-652">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-653">
            <span className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-white border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-654">
              Ce văd mereu la tineri
            </span>
            <h2 className="font-playfair text-[32px] md:text-[38px] text-rise-white mb-6" data-id="element-655">
              Tineri capabili. Blocați de frică și presiune.
            </h2>
            <p className="font-dm-sans text-[19px] text-rise-white/80 leading-relaxed" data-id="element-656">
              Am lucrat ani întregi cu tineri și am văzut același lucru în forme
              diferite: oameni inteligenți, sensibili, cu potențial, care nu se
              mișcă pentru că se simt prinși între:
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-657">
            <DarkCard title="Perfecționismul Paralizant" watermark="P" icon={<svg className="w-12 h-12" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-659">
                  <circle cx="24" cy="24" r="20" strokeDasharray="4 3" data-id="element-660" />
                  <circle cx="24" cy="24" r="12" data-id="element-661" />
                  <circle cx="24" cy="24" r="4" data-id="element-662" />
                  <line x1="24" y1="4" x2="24" y2="8" data-id="element-663" />
                  <line x1="24" y1="40" x2="24" y2="44" data-id="element-664" />
                  <line x1="4" y1="24" x2="8" y2="24" data-id="element-665" />
                  <line x1="40" y1="24" x2="44" y2="24" data-id="element-666" />
                </svg>} data-id="element-658">
              <p className="italic mb-4 text-rise-white/60" data-id="element-667">
                „Trebuie să aleg perfect."
              </p>
              <p data-id="element-668">
                Frica de a face o alegere greșită te ține pe loc, analizând la
                nesfârșit opțiunile fără a acționa.
              </p>
            </DarkCard>
            <DarkCard title="Frica de Eșec" watermark="E" icon={<svg className="w-12 h-12" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-670">
                  <path d="M24 4 L44 24 L24 44 L4 24 Z" data-id="element-671" />
                  <path d="M24 14 L34 24 L24 34 L14 24 Z" strokeDasharray="3 3" data-id="element-672" />
                  <line x1="24" y1="18" x2="24" y2="30" data-id="element-673" />
                  <circle cx="24" cy="33" r="1.5" fill="currentColor" stroke="none" data-id="element-674" />
                </svg>} data-id="element-669">
              <p className="italic mb-4 text-rise-white/60" data-id="element-675">
                „Dacă greșesc, am stricat tot."
              </p>
              <p data-id="element-676">
                Presiunea de a reuși din prima încercare transformă orice mică
                greșeală într-o catastrofă personală.
              </p>
            </DarkCard>
            <DarkCard title="Sindromul Impostorului" watermark="I" icon={<svg className="w-12 h-12" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-678">
                  <circle cx="24" cy="16" r="8" data-id="element-679" />
                  <path d="M10 44 C10 34 18 28 24 28 C30 28 38 34 38 44" data-id="element-680" />
                  <circle cx="24" cy="16" r="12" strokeDasharray="4 4" data-id="element-681" />
                  <line x1="16" y1="14" x2="20" y2="14" data-id="element-682" />
                  <line x1="28" y1="14" x2="32" y2="14" data-id="element-683" />
                </svg>} data-id="element-677">
              <p className="italic mb-4 text-rise-white/60" data-id="element-684">
                „Dacă nu sunt pregătit(ă), mai bine nu mă expun."
              </p>
              <p data-id="element-685">
                Senzația constantă că nu ești suficient de bun sau pregătit
                pentru a-ți asuma oportunități.
              </p>
            </DarkCard>
            <DarkCard title="Anxietatea Timpului" watermark="T" icon={<svg className="w-12 h-12" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-687">
                  <circle cx="24" cy="26" r="18" data-id="element-688" />
                  <polyline points="24 14 24 26 32 30" data-id="element-689" />
                  <line x1="20" y1="4" x2="28" y2="4" data-id="element-690" />
                  <line x1="24" y1="4" x2="24" y2="8" data-id="element-691" />
                  <path d="M8 10 L12 14" data-id="element-692" />
                  <path d="M40 10 L36 14" data-id="element-693" />
                </svg>} data-id="element-686">
              <p className="italic mb-4 text-rise-white/60" data-id="element-694">
                „Simt că pierd timpul și rămân în urmă."
              </p>
              <p data-id="element-695">
                Comparația constantă cu ceilalți și presiunea de a atinge
                anumite borne la o anumită vârstă.
              </p>
            </DarkCard>
          </div>
          <div className="text-center max-w-2xl mx-auto" data-id="element-696">
            <p className="font-dm-sans text-[19px] text-rise-gold font-medium" data-id="element-697">
              Problema nu e lipsa de ambiție. Problema e lipsa unei structuri
              care să transforme confuzia în direcție.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 3 — De ce fac asta (Light, photo left + text right) */}
      <section className="relative py-12 md:py-20 bg-rise-white overflow-hidden" data-id="element-698">
        <AboutDecorations data-id="element-699" />
        <div className="max-w-rise-content mx-auto px-6 relative z-10" data-id="element-700">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-701">
            <div className="order-2 lg:order-1 relative" data-id="element-702">
              <ImageDecorations type={2} data-id="element-703" />
              <img src="https://cdn.magicpatterns.com/uploads/5cTB7VyUXGVsL6aadBqWkg/Teodora_2.jpg" alt="Teodora Trifu" className="w-full h-auto aspect-[3/4] object-cover object-top rounded-xl shadow-xl relative z-10" data-id="element-704" />
            </div>
            <div className="order-1 lg:order-2" data-id="element-705">
              <span className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-black border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-706">
                De ce fac asta
              </span>
              <h2 className="font-playfair text-[32px] md:text-[38px] text-rise-black mb-6" data-id="element-707">
                De la lucru cu tinerii la o misiune clară
              </h2>
              <div className="space-y-6 font-dm-sans text-[19px] text-rise-gray leading-relaxed" data-id="element-708">
                <p data-id="element-709">
                  Lucrez de 9 ani cu copii și tineri, iar de 5 ani sunt
                  implicată direct în dezvoltarea emoțională a tinerilor din
                  medii defavorizate prin ONG-ul pe care l-am construit.
                </p>
                <p data-id="element-710">
                  Am înțeles repede ceva important: tinerii nu au nevoie doar de
                  inspirație. Au nevoie de un cadru sigur, de instrumente simple
                  și de o comunitate care îi susține fără să îi judece.
                </p>
                <p className="font-medium text-rise-black border-l-2 border-rise-gold pl-6 py-2" data-id="element-711">
                  Așa a apărut ideea R.I.S.E.: un mod clar de a construi
                  identitate, stabilitate și progres real, nu doar „încă un
                  episod de overthinking".
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 4 — Cum lucrez, pe scurt (Dark) */}
      <section className="py-12 md:py-20 bg-rise-anthracite" data-id="element-712">
        <div className="max-w-rise-content mx-auto px-6" data-id="element-713">
          <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-714">
            <span className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-white border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-715">
              Expertiză
            </span>
            <h2 className="font-playfair text-[32px] md:text-[38px] text-rise-white mb-6" data-id="element-716">
              Cum lucrez (pe scurt)
            </h2>
            <p className="font-dm-sans text-[19px] text-rise-white/70 leading-relaxed" data-id="element-717">
              Combin formare academică, experiență practică și metode creative,
              pentru ca procesul să fie clar, aplicat și uman.
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-718">
            <DarkCard title="Sunt formată ca" icon={<Briefcase size={28} data-id="element-720" />} data-id="element-719">
              <ul className="space-y-3" data-id="element-721">
                <CheckListItem data-id="element-722">
                  <span className="text-rise-white" data-id="element-723">
                    Lucrător prin arte combinate
                  </span>
                </CheckListItem>
                <CheckListItem data-id="element-724">
                  <span className="text-rise-white" data-id="element-725">
                    Consilier pentru dezvoltare personală
                  </span>
                </CheckListItem>
              </ul>
            </DarkCard>
            <DarkCard title="În munca mea combin" icon={<Wrench size={28} data-id="element-727" />} data-id="element-726">
              <ul className="space-y-3" data-id="element-728">
                <CheckListItem data-id="element-729">
                  <span className="text-rise-white" data-id="element-730">
                    Procese ghidate de autocunoaștere
                  </span>
                </CheckListItem>
                <CheckListItem data-id="element-731">
                  <span className="text-rise-white" data-id="element-732">
                    Reglare emoțională (practică, aplicabilă)
                  </span>
                </CheckListItem>
                <CheckListItem data-id="element-733">
                  <span className="text-rise-white" data-id="element-734">
                    Metode experiențiale și creative
                  </span>
                </CheckListItem>
                <CheckListItem data-id="element-735">
                  <span className="text-rise-white" data-id="element-736">
                    Structură + pași concreți (nu doar discuții)
                  </span>
                </CheckListItem>
              </ul>
            </DarkCard>
          </div>
        </div>
      </section>

      {/* SECTION 5 — Metoda R.I.S.E. (Light) */}
      <section className="py-12 md:py-20 bg-rise-white" data-id="element-737">
        <div className="max-w-rise-content mx-auto px-6" data-id="element-738">
          <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-739">
            <span className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-black border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-740">
              Metoda
            </span>
            <h2 className="font-playfair text-[32px] md:text-[38px] text-rise-black mb-6" data-id="element-741">
              R.I.S.E. – structura pe care o folosim în comunitate
            </h2>
            <p className="font-dm-sans text-[19px] text-rise-gray leading-relaxed" data-id="element-742">
              R.I.S.E. înseamnă 4 etape prin care treci când vrei să ieși din
              blocaj și să-ți construiești o viață cu sens:
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-743">
            <div className="bg-white border border-gray-200 shadow-sm rounded-xl p-8 flex flex-col relative" data-id="element-744">
              <div className="absolute top-0 left-0 w-full h-1 bg-rise-gold rounded-t-xl" data-id="element-745"></div>
              <div className="text-rise-gold mb-4" data-id="element-746">
                <EyeIcon data-id="element-747" />
              </div>
              <div className="font-playfair text-rise-gold text-[28px] mb-1" data-id="element-748">
                R
              </div>
              <h3 className="font-playfair text-rise-black text-[22px] mb-3" data-id="element-749">
                Realitate
              </h3>
              <p className="font-dm-sans text-rise-gray text-[16px] leading-relaxed" data-id="element-750">
                Înțelegi ce simți, fără rușine și fără fugă.
              </p>
            </div>
            <div className="bg-white border border-gray-200 shadow-sm rounded-xl p-8 flex flex-col relative" data-id="element-751">
              <div className="absolute top-0 left-0 w-full h-1 bg-rise-gold rounded-t-xl" data-id="element-752"></div>
              <div className="text-rise-gold mb-4" data-id="element-753">
                <FingerprintIcon data-id="element-754" />
              </div>
              <div className="font-playfair text-rise-gold text-[28px] mb-1" data-id="element-755">
                I
              </div>
              <h3 className="font-playfair text-rise-black text-[22px] mb-3" data-id="element-756">
                Identitate
              </h3>
              <p className="font-dm-sans text-rise-gray text-[16px] leading-relaxed" data-id="element-757">
                Valori, talente, direcție potrivită pentru tine.
              </p>
            </div>
            <div className="bg-white border border-gray-200 shadow-sm rounded-xl p-8 flex flex-col relative" data-id="element-758">
              <div className="absolute top-0 left-0 w-full h-1 bg-rise-gold rounded-t-xl" data-id="element-759"></div>
              <div className="text-rise-gold mb-4" data-id="element-760">
                <AnchorIcon data-id="element-761" />
              </div>
              <div className="font-playfair text-rise-gold text-[28px] mb-1" data-id="element-762">
                S
              </div>
              <h3 className="font-playfair text-rise-black text-[22px] mb-3" data-id="element-763">
                Stabilitate
              </h3>
              <p className="font-dm-sans text-rise-gray text-[16px] leading-relaxed" data-id="element-764">
                Plan clar + pași mici, constanți.
              </p>
            </div>
            <div className="bg-white border border-gray-200 shadow-sm rounded-xl p-8 flex flex-col relative" data-id="element-765">
              <div className="absolute top-0 left-0 w-full h-1 bg-rise-gold rounded-t-xl" data-id="element-766"></div>
              <div className="text-rise-gold mb-4" data-id="element-767">
                <TrendingUpIcon data-id="element-768" />
              </div>
              <div className="font-playfair text-rise-gold text-[28px] mb-1" data-id="element-769">
                E
              </div>
              <h3 className="font-playfair text-rise-black text-[22px] mb-3" data-id="element-770">
                Evoluție
              </h3>
              <p className="font-dm-sans text-rise-gray text-[16px] leading-relaxed" data-id="element-771">
                Mindset matur, progres pe termen lung.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 6 — Înainte de metode, sunt om (Dark) */}
      <section className="py-12 md:py-20 bg-rise-anthracite relative overflow-hidden" data-id="element-772">
        <div className="absolute top-0 right-0 w-72 h-72 bg-rise-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-773"></div>
        <div className="absolute bottom-0 left-0 w-72 h-72 bg-rise-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-774"></div>
        <div className="max-w-rise-content mx-auto px-6 relative z-10" data-id="element-775">
          <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-776">
            <span className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-white border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-777">
              Dincolo de titluri
            </span>
            <h2 className="font-playfair text-[32px] md:text-[38px] text-rise-white mb-8" data-id="element-778">
              Înainte de metode, sunt om
            </h2>
            <div className="space-y-6 font-dm-sans text-[19px] text-rise-white/80 leading-relaxed" data-id="element-779">
              <p data-id="element-780">
                Îmi place un stil de viață lent și conștient. Îmi place să
                învăț, să creez și să construiesc spații în care oamenii se simt
                în siguranță să fie ei.
              </p>
              <p className="text-rise-gold font-playfair italic text-[22px] md:text-[26px]" data-id="element-781">
                Cred în profunzime, dar și în simplitate. În emoții, dar și în
                acțiune. În comunitate, dar și în responsabilitate personală.
              </p>
            </div>
          </div>
          <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto mt-12" data-id="element-782">
            <div className="bg-rise-black border border-rise-gold/40 rounded-xl p-6 text-center" data-id="element-783">
              <Heart className="text-rise-gold mx-auto mb-3" size={28} data-id="element-784" />
              <p className="font-dm-sans text-rise-white/80 text-[15px]" data-id="element-785">
                Stil de viață lent, conștient
              </p>
            </div>
            <div className="bg-rise-black border border-rise-gold/40 rounded-xl p-6 text-center" data-id="element-786">
              <Palette className="text-rise-gold mx-auto mb-3" size={28} data-id="element-787" />
              <p className="font-dm-sans text-rise-white/80 text-[15px]" data-id="element-788">
                Învăț, creez, construiesc spații sigure
              </p>
            </div>
            <div className="bg-rise-black border border-rise-gold/40 rounded-xl p-6 text-center" data-id="element-789">
              <Compass className="text-rise-gold mx-auto mb-3" size={28} data-id="element-790" />
              <p className="font-dm-sans text-rise-white/80 text-[15px]" data-id="element-791">
                Profunzime + simplitate, emoții + acțiune
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 7 — Ce obțin oamenii când lucrează cu mine (Light) */}
      <section className="py-12 md:py-20 bg-rise-white" data-id="element-792">
        <div className="max-w-rise-content mx-auto px-6" data-id="element-793">
          <div className="text-center mb-12" data-id="element-794">
            <span className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-black border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-795">
              Rezultate reale
            </span>
            <h2 className="font-playfair text-[32px] md:text-[38px] text-rise-black mb-4" data-id="element-796">
              Ce obțin oamenii când lucrează cu mine
            </h2>
            <div className="w-24 h-1 bg-rise-gold mx-auto" data-id="element-797"></div>
          </div>
          <div className="max-w-3xl mx-auto bg-white border border-gray-200 shadow-sm rounded-xl p-8 md:p-12" data-id="element-798">
            <p className="font-dm-sans text-[19px] text-rise-gray mb-8" data-id="element-799">
              Oamenii cu care lucrez ajung să:
            </p>
            <div className="space-y-6" data-id="element-800">
              <div className="flex items-start gap-4" data-id="element-801">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={22} data-id="element-802" />
                <p className="font-dm-sans text-[18px] leading-relaxed" data-id="element-803">
                  <span className="font-semibold text-rise-black" data-id="element-804">
                    Își înțeleagă emoțiile
                  </span>
                  <span className="text-rise-gray" data-id="element-805">
                    {' '}
                    și să nu se mai sperie de ele.
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-806">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={22} data-id="element-807" />
                <p className="font-dm-sans text-[18px] leading-relaxed" data-id="element-808">
                  <span className="font-semibold text-rise-black" data-id="element-809">
                    Ia decizii mai clare
                  </span>
                  <span className="text-rise-gray" data-id="element-810">
                    , fără autocritică paralizantă.
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-811">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={22} data-id="element-812" />
                <p className="font-dm-sans text-[18px] leading-relaxed" data-id="element-813">
                  <span className="font-semibold text-rise-black" data-id="element-814">
                    Pună limite
                  </span>
                  <span className="text-rise-gray" data-id="element-815"> fără vinovăție.</span>
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-816">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={22} data-id="element-817" />
                <p className="font-dm-sans text-[18px] leading-relaxed" data-id="element-818">
                  <span className="font-semibold text-rise-black" data-id="element-819">
                    Facă pași concreți
                  </span>
                  <span className="text-rise-gray" data-id="element-820">
                    {' '}
                    în direcția lor (nu doar planuri).
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-821">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={22} data-id="element-822" />
                <p className="font-dm-sans text-[18px] leading-relaxed" data-id="element-823">
                  <span className="font-semibold text-rise-black" data-id="element-824">
                    Simtă stabilitate
                  </span>
                  <span className="text-rise-gray" data-id="element-825">
                    {' '}
                    și încredere în viața de zi cu zi.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 8 — Final CTA (Dark intens) */}
      <section className="py-14 md:py-24 bg-rise-black text-center relative overflow-hidden" data-id="element-826">
        <div className="absolute inset-0 opacity-10 pointer-events-none flex items-center justify-center" data-id="element-827">
          <div className="w-[800px] h-[800px] border-[1px] border-rise-gold rounded-full" data-id="element-828"></div>
          <div className="absolute w-[600px] h-[600px] border-[1px] border-rise-gold rounded-full" data-id="element-829"></div>
          <div className="absolute w-[400px] h-[400px] border-[1px] border-rise-gold rounded-full" data-id="element-830"></div>
        </div>
        <div className="max-w-rise-content mx-auto px-6 relative z-10" data-id="element-831">
          <h2 className="font-playfair text-[36px] md:text-[48px] text-rise-white mb-6" data-id="element-832">
            Vrei să ieși din blocaj și să începi, pe bune?
          </h2>
          <p className="font-dm-sans text-[19px] text-rise-white/80 mb-12 max-w-2xl mx-auto" data-id="element-833">
            Nu trebuie să faci asta singur(ă). Alege varianta care ți se
            potrivește acum.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-8" data-id="element-834">
            <Button variant="primary" href="https://comunitatearise.ro/ofertarise" target="_top" className="text-[16px] py-5 px-10" data-id="element-835">
              Intră în Programul R.I.S.E.
            </Button>
            <Button variant="primary" href="https://comunitatearise.ro/comunitaterise" target="_top" className="text-[16px] py-5 px-10" data-id="element-836">
              Intră în Comunitatea R.I.S.E.
            </Button>
            <Button variant="primary" href="https://comunitatearise.ro/coaching1la1" target="_top" className="text-[16px] py-5 px-10" data-id="element-837">
              Aplică pentru 1:1 cu Teodora
            </Button>
          </div>
          <p className="font-dm-sans text-[14px] text-rise-white/50 italic" data-id="element-838">
            Locuri limitate la 1:1 și în Programul R.I.S.E. (max 20 persoane).
          </p>
        </div>
      </section>
    </main>;
}